import { MAP_LAYER } from 'components/Map/constants';
import { STATIC_ZOOM } from 'components/MapBox/hooks/useLayers/layers/constants';

export const TEST_ID = 'mapInternal';

export const STATIC_LAYER_IDS = [
    MAP_LAYER.STATIC_BOUNDARY_FILL,
    MAP_LAYER.STATIC_BOUNDARY_OUTLINE,
    MAP_LAYER.STATIC_BOUNDARY_OUTLINE_MODIFIED,
    MAP_LAYER.STATIC_OBSTACLE_FILL,
    MAP_LAYER.STATIC_BOUNDING_BOX_OUTLINE,
    MAP_LAYER.STATIC_OBSTACLE_BOUNDING_BOX_OUTLINE
];

export const EMPTY_PARTS: [] = [];

export const SINGLE_BOUNDARY_COUNT = 1;

export { STATIC_ZOOM };

export { GEOJSON_PROPERTY } from 'components/Map/hooks/useFeatures/constants';
